module.exports = __webpack_public_path__ + "img/header-left.caa96502.png";